var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#202124",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M21.227 28a4.046 4.046 0 1 0 0-8.09 4.046 4.046 0 0 0 0 8.09M21.227 9.12a4.046 4.046 0 1 0 0-8.09 4.046 4.046 0 0 0 0 8.09M5.046 18.561a4.046 4.046 0 1 0 0-8.091 4.046 4.046 0 0 0 0 8.091"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#202124",
  strokeWidth: 2,
  d: "m17.858 7.099-9.44 5.394M8.418 16.537l9.44 5.394"
})));
export default SvgShare;